import React, {useCallback, useEffect} from "react";
import RedirectLogo from "../../assets/images/logo_redirect.svg";
import {Box, CircularProgress, Typography} from "@material-ui/core";
import * as actions from "../../store";
import {useDispatch} from "react-redux";
import {TOKEN_NAME} from "../../shared/utils/constants/storage";
import {useRedirectStyles} from "./RedirectStyles";

const Redirect = () => {
    const classes = useRedirectStyles()
    const dispatch = useDispatch()

    const getAuthToken = useCallback(() => {
        dispatch(actions.samlAuth())
        const interval = setInterval(() => {
            if (sessionStorage.getItem(TOKEN_NAME)) {
                clearInterval(interval);
            } else {
                dispatch(actions.samlAuth())
            }
        }, 180000);
    }, [dispatch])

    useEffect(() => {
        getAuthToken();
    }, [getAuthToken]);

    return (
        <Box className={classes.root}>
            <Box className={classes.boxWrapper}>
                <img src={RedirectLogo} alt="redirect-logo"/>
                <Box className={classes.card}>
                    <Typography variant="h5" className={classes.title}>
                        Authentication Redirect
                    </Typography>
                    <Typography variant="body2">Redirecting, please wait...</Typography>
                    <Box className={classes.progress}>
                        <CircularProgress size={50}/>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default Redirect
